import { HTTP_CLIENT } from "../utils/services";

const despositLegacy = async (params) => {
  return await HTTP_CLIENT.post("request/create-legacy-deposit", params);
};
const despositGetRates = async (params) => {
  return await HTTP_CLIENT.get(`/native-token/get-rate/${params}`);
};
export { despositLegacy, despositGetRates };
